export const layoutAttributes = {
  marginLeft: 65,
  marginBottom: 50,
};

export const graphRenderAttribute = {
  backgroundColor: 0x000000,
  batchSize: 150000,
};

export const highlightAttributes = {
  sizePx: 15,
  hoverRadiusPx: 40,
};

export const cameraConstants = {
  bounds: 1000,
  near: -1000,
  far: 1000,
};

export const zoomProperties = {
  inFactor: 1.1,
  outFactor: 100 / 110,
};

export const slopeLineWidthPx = 2;

const tickTextHeight = 12;
const axisLabelGap = 6;

export const axisProperties = {
  tick: {
    padding: 10,
    textHeight: tickTextHeight,
    labelGap: axisLabelGap,
    minX: 2,
    minY: 2,
    xSpacing: 100,
    ySpacing: 50,
  },
  label: {
    xAxis: 'DISTANCE (M)',
    yAxis: 'ELEVATION (M)',
    xOffset: 10 + tickTextHeight + axisLabelGap, // 28px
    yOffset: 10,
  },
};

export const dataComponents = {
  sourcePositionComponents: 4, // [mileage, 0, elevation, 0]
  targetPositionComponents: 3, // [mileage, 0, elevation]
  colorComponents: 3, // [r, g, b]
};

export const textureProperties = {
  canvasSize: 64,
  circleRadius: 32,
  highlightOuterRadius: 32,
  highlightInnerRadius: 21,
};

export const colorConstants = {
  highlight: 'rgba(118, 74, 226, 1.0)',
  slopeLine: 'rgba(176, 18, 18, 1.0)',
  white: 'rgba(255, 255, 255, 1.0)',
};

// DXF export constants.
export const dxfConstants = {
  gridlineLayerName: 'cross-section-gridlines',
  gridlineLayerColor: 4,
  gridlineLineType: 'CONTINUOUS',
  gridlineColor: 0x71828e,
  pointLayerColor: 6,
  pointLayerNamePrefix: 'cross-section-points',
  axisPadding: 10,
  gridlineCount: 10,
  gridlineWidth: 0.01,
  tickTextSize: 2,
  tickDecimalPlaces: 2,
  tickLabelOffsetX: -10,
  tickLabelOffsetY: -5,
  axisLabelTextSize: 3,
  axisLabelOffsetX: -25,
  axisLabelOffsetY: -15,
  axisLabelRotation: 90,
  defaultPointSizePercent: 0.002,
  pointSizeScaleFactor: 5,
  pointSizeMultiplier: 0.001,
  positionComponentsPerPoint: 4,
  positionYOffset: 3,
  colorComponentsPerPoint: 3,
};

export const rgbBitShift = {
  red: 16,
  green: 8,
  blue: 0,
};
